import { Allocation } from './Allocation';
import { BaseModel } from './BaseModel';

export interface SubdomainWebServing {
    sslMode: string;
    status: string;
    error: string | null;
    syncedAt: string | null;
    servedCentrally: boolean;
    servingHostname: string;
}

export class ServerSubdomain extends BaseModel {
    public id = '';
    public name: string | null = null;
    public displayName = '';
    public isCustomDomain = false;
    public hasSrv = false;
    public web: SubdomainWebServing | null = null;

    public get allocation(): Allocation | undefined {
        return this.getRelationship('allocation');
    }

    public get webAllocation(): Allocation | undefined {
        return this.getRelationship('webAllocation');
    }
}
